import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Report from "@/components/valuation/Report";

/**
 * Dedicated results page reached via navigate('/result', { state: { report, firstName } })
 * so the URL /result uniquely identifies the "valuation completed" moment for GTM.
 */
export default function Result() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // If someone lands on /result without valuation state, send them home.
  useEffect(() => {
    if (!state || !state.report) navigate("/", { replace: true });
  }, [state, navigate]);

  if (!state || !state.report) return null;

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-background/70 backdrop-blur-xl border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="result-home">
            <img src="/salons-for-sale.png" alt="Salons For Sale" className="h-12 w-auto" />
          </Link>
          <button
            data-testid="result-done"
            onClick={() => navigate("/")}
            className="eyebrow text-muted-foreground hover:text-brand transition-colors"
          >
            Done
          </button>
        </div>
      </header>
      <div className="px-6 md:px-10 py-16 md:py-24">
        <Report report={state.report} firstName={state.firstName} />
      </div>
    </div>
  );
}
